import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import { FAILURE_ADMIN_PRODUCT_GROUPS, REQUEST_ADMIN_PRODUCT_GROUPS, SUCCESS_ADMIN_PRODUCT_GROUPS } from './actions';

export function adminProductGroupsReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ADMIN_PRODUCT_GROUPS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ADMIN_PRODUCT_GROUPS:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_ADMIN_PRODUCT_GROUPS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}
